"use strict";
// import copy from "copy-to-clipboard";

const navLinks = document.querySelectorAll(".overlay .nav-link");
const toggler = document.querySelector("#navbar-toggler");
const overlay = document.querySelector("#overlay");
const overlayBg = document.querySelector("#overlay-bg");
const hamIcon = document.querySelector("#ham");
const closeIcon = document.querySelector("#close");
const phoneBox = document.querySelector("#phone-container");
const copyPhone = document.querySelector("#copyPhone");
const copyMail = document.querySelector("#copyMail");
const phoneBtn = document.querySelector("#phone-btn");
const emailBtn = document.querySelector("#email-btn");
const emailBox = document.querySelector("#email-container");

// toggle navigation on small screen

let isNavOn = false;
const openNav = () => {
  overlay.classList.remove("d-none");
  overlayBg.classList.remove("d-none");
  hamIcon.classList.add("d-none");
  closeIcon.classList.remove("d-none");
  toggler.ariaHidden = "false";
};

const closeNav = () => {
  overlay.classList.add("d-none");
  overlayBg.classList.add("d-none");
  hamIcon.classList.remove("d-none");
  closeIcon.classList.add("d-none");
  toggler.ariaHidden = "true";
};

const toggleNav = () => {
  isNavOn ? closeNav() : openNav();
  isNavOn = !isNavOn;
};

toggler.addEventListener("click", toggleNav);

navLinks.forEach((navLink) =>
  navLink.addEventListener("click", () => {
    toggleNav();
  })
);

if (window.screen.width > 575) {
  closeNav();
  isNavOn = false;
} else {
  toggler.ariaHidden = "false";
}

// toggle phone number display

let isPhoneDisplayed = false;

const togglePhoneDisplay = () => {
  if (isPhoneDisplayed) {
    phoneBox.classList.add("d-none");
  } else {
    phoneBox.classList.remove("d-none");
    phoneBox.scrollIntoView();
  }

  isPhoneDisplayed = !isPhoneDisplayed;
};

phoneBtn.addEventListener("click", togglePhoneDisplay);

// if (module.hot) {
//   module.hot.accept();
// }

// toggle email number display

let isemailDisplayed = false;

const toggleEmailDisplay = () => {
  if (isemailDisplayed) {
    emailBox.classList.add("d-none");
  } else {
    emailBox.classList.remove("d-none");
    emailBox.scrollIntoView();
  }

  isemailDisplayed = !isemailDisplayed;
};

emailBtn.addEventListener("click", toggleEmailDisplay);

// if (module.hot) {
//   module.hot.accept();
// }

// copy to clipboard

// const setAlert = (message, timeout = 7000) => {
//   contactBtn.insertAdjacentHTML(
//     "beforebegin",
//     `
//     <div id="mail-alert" class="text-center mail-alert">
//       <div class="inner-mail-alert">
//         ${message}
//       </div>
//     </div>
//   `
//   );

//   setTimeout(() => {
//     if (document.querySelector("#mail-alert")) {
//       document.querySelector("#mail-alert").remove();
//     }
//   }, timeout);
//   contactBtn.scrollIntoView();
//   return;
// };

copyPhone.addEventListener("click", async () => {
  try {
    if (!navigator.clipboard) throw new Error("clipboard api not supported");

    await navigator.clipboard?.writeText("9818745379");
    if (copyPhone.classList.contains("bi-clipboard")) {
      copyPhone.classList.remove("bi-clipboard");
      copyPhone.classList.add("bi-clipboard-check");
    }
  } catch (err) {
    console.log(err);
  }
});

copyMail.addEventListener("click", async () => {
  try {
    if (!navigator.clipboard) throw new Error("clipboard api not supported");

    await navigator.clipboard?.writeText("rishi18454@gmail.com");
    if (copyMail.classList.contains("bi-clipboard")) {
      copyMail.classList.remove("bi-clipboard");
      copyMail.classList.add("bi-clipboard-check");
    }
  } catch (err) {
    console.log(err);
  }
});
